<h1 class="title">Confluence Categories</h1>
<ng-select
  [items]="categories"
  placeholder="Select Category"
  [(ngModel)]="selectedCategories"
  (change)="selectCategories($event)"
  [multiple]="true"
></ng-select>
